import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { ShoppingCart } from 'lucide-react';
import { servicePricing } from '../../mockData';

const ECommerce = () => {
  const features = [
    {
      title: "Payment Gateway Integration",
      description: "Secure payment processing with Stripe, PayPal, and other providers"
    },
    {
      title: "Inventory Management",
      description: "Real-time stock tracking and automated inventory updates"
    },
    {
      title: "Shopping Cart & Checkout",
      description: "Smooth, conversion-optimized checkout experience"
    },
    {
      title: "Product Management",
      description: "Easy-to-use admin panel for managing products and categories"
    },
    {
      title: "Customer Accounts",
      description: "User profiles, order history, and wishlist functionality"
    },
    {
      title: "Analytics Dashboard",
      description: "Track sales, revenue, and customer behavior insights"
    }
  ];

  const benefits = [
    {
      title: "Increased Sales",
      description: "Reach customers 24/7 and sell products worldwide without physical limitations"
    },
    {
      title: "Lower Operating Costs",
      description: "Reduce overhead compared to traditional brick-and-mortar stores"
    },
    {
      title: "Customer Insights",
      description: "Understand buying patterns and preferences through detailed analytics"
    },
    {
      title: "Scalable Platform",
      description: "Easily add products and features as your business grows"
    }
  ];

  const process = [
    {
      title: "Store Planning",
      description: "Define product catalog, payment options, and shipping strategy"
    },
    {
      title: "Design & UX",
      description: "Create beautiful product pages and smooth checkout flow"
    },
    {
      title: "Development & Integration",
      description: "Build store with payment gateways, inventory, and shipping APIs"
    },
    {
      title: "Testing & Launch",
      description: "Thorough testing of transactions, then launch and market your store"
    }
  ];

  // Using web development pricing as base for e-commerce
  const ecommercePricing = [
    {
      id: 1,
      name: "Basic Store",
      price: "$3,999",
      period: "one-time",
      description: "Perfect for small shops starting online",
      features: [
        "Up to 50 products",
        "Payment gateway integration",
        "Basic inventory management",
        "Mobile-responsive design",
        "SSL certificate included",
        "2-month support"
      ],
      color: "#f6fd87",
      popular: false
    },
    {
      id: 2,
      name: "Professional Store",
      price: "$8,999",
      period: "one-time",
      description: "Full-featured e-commerce platform",
      features: [
        "Unlimited products",
        "Multiple payment gateways",
        "Advanced inventory system",
        "Customer accounts & reviews",
        "Email marketing integration",
        "Analytics dashboard",
        "4-month support"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Enterprise Store",
      price: "$25,000+",
      period: "custom",
      description: "Large-scale marketplace solution",
      features: [
        "Multi-vendor marketplace",
        "Custom integrations (ERP, CRM)",
        "Advanced analytics & BI",
        "Multi-currency & language",
        "API for mobile apps",
        "Dedicated support team",
        "12-month support"
      ],
      color: "#88a2ff",
      popular: false
    }
  ];

  return (
    <ServicePageTemplate
      title="E-Commerce Development"
      subtitle="Launch Your Online Store"
      description="Full-featured e-commerce solutions with secure payments, inventory management, and analytics. Start selling online and grow your business globally."
      features={features}
      benefits={benefits}
      pricing={ecommercePricing}
      icon={ShoppingCart}
      bgColor="#f6fd87"
      process={process}
    />
  );
};

export default ECommerce;